import {
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import RoleService from "services/RoleService";
import CheckboxTick from "assets/CheckboxTick.svg";
import CheckboxUntick from "assets/CheckboxUntick.svg";
import { AuthData } from "auth/AuthWarpper";
import { useLocation, useNavigate } from "react-router-dom";
import { SnackbarContext } from "context/snackBarContext";
import UserService from "services/UserService";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import DelegationService from "services/DelegationService";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
import { useTranslation } from "react-i18next";

const DelegationUpdate = () => {
  const location = useLocation();
  const [errors, setErrors] = useState({});
  const { user } = AuthData();
  const navigate = useNavigate();
  const {t,i18n} = useTranslation()
  const { rowData } = location.state || {};
  const { setOpenAlert, setSeverity, setMessage, handleClose } =
    useContext(SnackbarContext);
  const [userName, setUserName] = useState(rowData?.data?.userName || "");
  const [isActive, setIsActive] = useState(
    rowData?.data?.active === "Active" ? "Active" : "Active"
  );
  const [formData, setFormData] = useState({
    profile: rowData?.data?.batOneId || "",
    fieldTechnician: "",
    role: rowData?.data?.profileId || "",
    serviceNumber: rowData?.data?.serviceNumber || "",
    remarks: rowData?.data?.remarks || "",
    countryCode: rowData?.data?.countryCode || "",
    fromBatId: "",
    toBatId: "",
  });

  const [loading, setLoading] = React.useState(false);
  const [StartDate, setStartDate] = useState(rowData?.data?.startDate || "");
  const [EndDate, setEndDate] = useState(rowData?.data?.endDate || "");
  const fetchRoles = async () => {
    try {
      const response = await RoleService.getActiveRoles();
      if (response.data?.statusCode === 200) {
        // setRoleOptions(response.data.response);
      } else {
        console.error("Error fetching roles:", response.data.message);
      }
    } catch (error) {
      console.error("API call error:", error);
    }
  };



  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleChangeCountry = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        isActive: isActive === "Active" ? true : false,
        toBATID: formData.profile,
        fromBATID: user?.batOneId,
        startDate: StartDate,
        // endDate: endDate,
        createdByUser: user.userName,
        modifiedByUser: user.userName,
        createdDateTimeUTC: new Date().toISOString(),
        modifiedDateTimeUTC: new Date().toISOString(),
      };

      setLoading(true);
  
      const response = await DelegationService.createDelegation(payload);
      setLoading(false);

      if (response.status === 201) {
        // Show success snackbar
        navigate("/roleCreation");
        setSeverity("success");
        setMessage("Added successfully");
        setOpenAlert(true);
        setLoading(false);
      } else {
        console.error("Failed to submit form");
        // Show error snackbar
        setSeverity("error");
        setMessage("Failed to submit form");
        setOpenAlert(true);
      }
    } catch (error) {
      setLoading(false);
      let newError = {};
      if (error?.name && error.name === "ValidationError") {
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
          setErrors(newError || error?.message);
          return;
        });
      } else {
        setSeverity("error");
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
      }
    }
  };

  const handleSubmitMulti = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        isActive: isActive === "Active" ? true : false,
        toBATID: formData?.toBatId,
        fromBATID: formData?.fromBatId,
        startDate: StartDate,
        // endDate: endDate,
        createdByUser: user.userName,
        modifiedByUser: user.userName,
        createdDateTimeUTC: new Date().toISOString(),
        modifiedDateTimeUTC: new Date().toISOString(),
      };
      setLoading(true);
      const response = await DelegationService.createDelegation(payload);
      setLoading(false);
      if (response.status === 201) {
        navigate("/roleCreation");
        setSeverity("success");
        setMessage("Added successfully");
        setOpenAlert(true);
      } else {
        console.error("Failed to submit form");
        setSeverity("error");
        setMessage("Failed to submit form");
        setOpenAlert(true);
      }
    } catch (error) {
      setLoading(false);
      let newError = {};
      if (error?.name && error.name === "ValidationError") {
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
          setErrors(newError || error?.message);
          return;
        });
      } else {
        setSeverity("error");
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
      }
    }
  };

  const [profileData, setProfileData] = useState([]);
  const [match, setMatch] = useState(false);
  const handleChangeText = (e) => {
    setFormData({ ...formData, profile: e.target.value });
  };
  const [batData, setBatData] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fetchProfileData = async () => {
      if (formData.profile) {
        try {
          const response = await DelegationService.checkSameRole({
            loginBatID: user?.batOneId,
            delegatorBATID: formData?.profile,
          });


          if (response?.data?.response !== match) {
            setMatch(response?.data?.response);
          }
        } catch (error) {
          console.error("Error fetching profile data:", error);
          setSeverity("error");
          setMessage(error?.response?.data?.message);
          setOpenAlert(true);
        }
      }
    };

    fetchProfileData();
  }, [formData.profile, user?.batOneId, match]);

  const [multiMatch, setMultiMatch] = useState(false);

  useEffect(() => {
    let isMounted = true; // Track if the component is mounted

    const fetchProfileData = async () => {
      if (formData.fromBatId && formData.toBatId) {
        try {
          const response = await DelegationService.checkSameRole({
            loginBatID: formData.fromBatId,
            delegatorBATID: formData.toBatId,
          });
          // Only update state if the component is still mounted and the response is different
          if (isMounted && response?.data?.response !== multiMatch) {
            setMultiMatch(response?.data?.response);
          }
        } catch (error) {
          if (isMounted) {
            console.error("Error fetching profile data:", error);
            setSeverity("error");
            setMessage(error?.response?.data?.message || "An error occurred");
            setOpenAlert(true);
          }
        }
      }
    };

    fetchProfileData();

    return () => {
      isMounted = false; // Cleanup function to avoid state updates if unmounted
    };
  }, [formData.fromBatId, formData.toBatId, multiMatch]); // Add 'match' to dependency array if you want the effect to re-run when it changes

  useEffect(() => {
    const fetchUserData = async () => {
      if (match) {
        try {
          const response = await UserService.FindAdUser(formData.profile);
          // Only update state if the response is different
          setBatData(response?.data?.response);
          setUserName(
            `${response?.data?.response?.givenName ?? ""} ${response?.data?.response?.surName ?? ""
              }`.trim()
          );
        } catch (error) {
          console.error("Error fetching user data:", error);
          setSeverity("error");
          setMessage(error?.response?.data?.message);
          setOpenAlert(true);
        }
      }
    };

    fetchUserData();
  }, [match]); // Depend on match to avoid unnecessary re-renders

  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    const fetchUserData = async () => {
      if (formData.fromBatId) {
        try {
          const response = await UserService.FindAdUser(formData.fromBatId);
          setUserName(
            `${response?.data?.response?.givenName ?? ""} ${response?.data?.response?.surName ?? ""
              }`.trim()
          );
          setUserEmail(response?.data?.response?.mail);
        } catch (error) {
          console.error("Error fetching user data:", error);
          setSeverity("error");
          setMessage(error?.response?.data?.message);
          setOpenAlert(true);
        }
      }
    };

    fetchUserData();
  }, [formData.fromBatId]);

  const [toUserName, setToUserName] = useState("");
  const [toEmail, setToEmail] = useState("");

  useEffect(() => {
    const fetchUserData = async () => {
      if (multiMatch) {
        try {
          const response = await UserService.FindAdUser(formData.toBatId);
          setToUserName(
            `${response?.data?.response?.givenName ?? ""} ${response?.data?.response?.surName ?? ""
              }`.trim()
          );
          setToEmail(response?.data?.response?.mail);
        } catch (error) {
          console.error("Error fetching user data:", error);
          setSeverity("error");
          setMessage(error?.response?.data?.message);
          setOpenAlert(true);
        }
      }
    };
    fetchUserData();
  }, [multiMatch]);

  const toggleIsActive = () => {
    setIsActive((prevIsActive) =>
      prevIsActive === "Active" ? "InActive" : "Active"
    );
  };

  const handleChangeDate = (date) => {
    setStartDate(date); // Store the selected date
  };


  const [openEnd, setOpenEnd] = useState(false);

  const handleChangeDateEnd = (date) => {
    setEndDate(date); // Store the selected date
  };
  const onUpdateDelegation = () => {
    if (isActive == "Active") {
      navigate(`/${rowData?.fromUrl}`)
    } else {
      let data = {
        delegation: rowData?.data?.delegationId,
        userName: user?.userName
      }
      RoleService.updateDelegation(data)
        .then((res) => {
          setMessage("Updated Successfully")
          setOpenAlert(true)
          setSeverity("success")
          navigate(`/${rowData?.fromUrl}`)
        })
        .catch((error) => {
          setMessage(error?.response?.data?.message || error?.message)
          setOpenAlert(true)
          setSeverity("error")
          console.error("API call failed:", error);
        })
    }

  }
  return (
    <LayoutAccessManagement>
      <Box sx={{ paddingBottom: "150px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "65vh",
            background: "#f0f3f6",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            padding: "25px",
            borderRadius: "6px",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          {toUserName === "" && (
            <Box
              sx={{
                background: "#ffffff",
                width: "473px",
                display: "flex",
                flexDirection: "column",
                gap: "15px",
                borderRadius: "16px",
                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
              }}
            >

              {rowData?.fromUrl == "UserCreation" &&
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    fontWeight: 500,
                    color: "#191E31",
                    borderBottom: "2px solid #CFD5E0",
                    p: 2,
                  }}
                >
                  <Typography sx={{ fontWeight: 500, color: "#191E31", fontFamily: "Montserrat" }}>
                    BAT One ID:{rowData?.data?.fromBATID}
                    {`${batData?.givenName ?? ""} ${batData?.surName ?? ""}`}
                  </Typography>
                  <Typography sx={{ fontWeight: 500, color: "#191E31", fontFamily: "Montserrat" }}>
                    Name:{rowData?.data?.fromName}
                    {`${batData?.givenName ?? ""} ${batData?.surName ?? ""}`}
                  </Typography>
                  <Typography sx={{ fontWeight: 500, color: "#191E31", fontFamily: "Montserrat" }}>
                    Email: {rowData?.data?.fromEmail}
                  </Typography>
                </Box>
              }

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: 500,
                  color: "#191E31",
                  borderBottom: "2px solid #CFD5E0",
                  p: 2,
                }}
              >
                <Typography sx={{ fontWeight: 500, color: "#191E31", fontFamily: "Montserrat" }}>
                  BAT One ID:{rowData?.data?.toBATID}
                  {`${batData?.givenName ?? ""} ${batData?.surName ?? ""}`}
                </Typography>
                <Typography sx={{ fontWeight: 500, color: "#191E31", fontFamily: "Montserrat" }}>
                  Name:{rowData?.data?.toName}
                  {`${batData?.givenName ?? ""} ${batData?.surName ?? ""}`}
                </Typography>
                <Typography sx={{ fontWeight: 500, color: "#191E31", fontFamily: "Montserrat" }}>
                  Email: {rowData?.data?.toEmail}
                </Typography>
              </Box>

              <Box sx={{ p: 2, borderBottom: "2px solid #CFD5E0" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    sx={{
                      width: {
                        sx: "100%",
                        md: "100% !important",
                        xl: "100%",
                      },
                    }}
                    components={["DatePicker"]}
                  >
                    <DatePicker
                      sx={{
                        width: {
                          sx: "100%",
                          md: "100% !important",
                          xl: "100%",
                        },
                      }}
                      id="selectDate"
                      name="selectDate"
                      open={open}
                      onClose={() => setOpen(false)}
                      label="Select Date"
                      format="DD/MM/YYYY"
                      value={StartDate ? dayjs(StartDate) : null}
                      // onChange={(date) => handleChangeDate(date)}
                      renderInput={(params) => (
                        <TextField {...params} error={false} helperText="" />
                      )}
                      slotProps={{
                        field: {
                          readOnly: true,
                        },
                        textField: {
                          // onClick: () => setOpen(true),
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    sx={{
                      width: {
                        sx: "100%",
                        md: "100% !important",
                        xl: "100%",
                        paddingTop:"20px"
                      },
                    }}
                    components={["DatePicker"]}
                  >
                    <DatePicker
                      sx={{
                        width: {
                          sx: "100%",
                          md: "100% !important",
                          xl: "100%",
                        },
                      }}
                      id="endDate"
                      name="endDate"
                      open={openEnd}
                      onClose={() => setOpenEnd(false)}
                      label="End Date"
                      format="DD/MM/YYYY"
                      value={EndDate ? dayjs(EndDate) : null}
                      // onChange={(date) => handleChangeDateEnd(date)}
                      renderInput={(params) => (
                        <TextField {...params} error={false} helperText="" />
                      )}
                      slotProps={{
                        field: {
                          readOnly: true,
                        },
                        textField: {
                          // onClick: () => setOpenEnd(true),
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Box>
              <>
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                      pb: 2,
                      cursor: "pointer",
                      borderBottom: "2px solid #CFD5E0",
                    }}
                    onClick={toggleIsActive}
                  >
                    <img
                      src={
                        isActive === "Active" ? CheckboxTick : CheckboxUntick
                      }
                      alt="checkbox"
                    />
                    <Typography>
                      {isActive === "Active" ? "Active" : "Inactive"}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    gap: "20px",
                    p: 2,
                  }}
                >
                  <Button
                    sx={{
                      borderRadius: 2,
                      background: "#102A62",
                      color: "#ffffff",
                      fontWeight: 600,
                      height: 54,
                      width: { xs: "100%", md: "156px" },
                      "&:hover": {
                        backgroundColor: "#102A62",
                      },
                    }}
                    onClick={() => onUpdateDelegation()}
                  >
                    {t("update")}
                  </Button>
                </Box>
              </>
            </Box>
          )}
        </Box>
      </Box>
    </LayoutAccessManagement>
  );
};

export default DelegationUpdate;
